module.exports = __webpack_public_path__ + "static/media/on_any_device-fs8.ec8d41fb.jpg";